import { Injectable } from '@angular/core';
declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root',
})
export class VoiceRecognitionObjectiveService {
  recognition = new webkitSpeechRecognition();
  isStoppedSpeechRecog = false;
  public Objective = '';
  private instantStarted = false;
  tempWords;

  constructor() {}

  init() {
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-US';

    this.recognition.addEventListener('result', (e) => {
      const transcript = Array.from(e.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join('');
      this.tempWords = transcript;
      // console.log(transcript);
    });
  }

  startObjective() {
    if (!this.instantStarted) {
      this.isStoppedSpeechRecog = false;
      this.recognition.start();
      this.instantStarted = true;
      // console.log('Speech recognition started');
      this.recognition.addEventListener('end', (condition) => {
        if (this.isStoppedSpeechRecog) {
          this.recognition.stop();
          // console.log('End speech recognition');
        } else {
          this.wordConcatObjective();
          this.recognition.start();
        }
      });
    }
  }
  stopObjective() {
    if (this.instantStarted) {
      this.isStoppedSpeechRecog = true;
      this.wordConcatObjective();
      this.recognition.stop();
      this.instantStarted = false;
      // console.log('End speech recognition');
    }
  }

  wordConcatObjective() {
    this.Objective = this.Objective + ' ' + this.tempWords + '.';
    this.tempWords = '';
  }
}
